import { render, staticRenderFns } from "./walletInfo.vue?vue&type=template&id=636e9e5b&"
import script from "./walletInfo.vue?vue&type=script&lang=js&"
export * from "./walletInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports